/**
 * 
 * @param {Function} condition 
 * @param {Number} millis 
 */
async function waitUntil (condition = () => true, millis = 5000) {
  const start = Date.now()
  while ((!condition() && Date.now() - start < millis)) {
    await new Promise((resolve) => setTimeout(resolve, 50))
  }
}

export default waitUntil
